import { render, staticRenderFns } from "./OrderableCustomShippingInputs.vue?vue&type=template&id=642fcf98&"
import script from "./OrderableCustomShippingInputs.vue?vue&type=script&lang=ts&"
export * from "./OrderableCustomShippingInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports